import { z } from 'zod';
import type { IdType } from '@/components/FilterChip/IdTypeFilterChip';
import { OrderDirection } from '@/constants/orderDirection';
import type { ApiSearchQuery } from '@/lib/api/api-type-helper';
type AppCategory = NonNullable<ApiSearchQuery<'/v2/accesses/software', 'get'>['categoryIn']>[number];
const AppCategorySchema = z.enum(['COMMUNICATION', 'DESIGN', 'DEVELOPMENT', 'STORAGE', 'FINANCE_AND_ACCOUNTING', 'GENERAL_AFFAIRS', 'HUMAN_RESOURCES', 'IT_SECURITY', 'LEGAL', 'MARKETING', 'PROJECT_MANAGEMENT', 'SALES_CRM', 'AI', 'CONSTRUCTION_REAL_ESTATE', 'DATA_ANALYTICS', 'EDUCATION', 'HEALTHCARE', 'MANUFACTURING_SUPPLY_CHAIN', 'RETAIL_ECOMMERCE', 'INDUSTRY_SPECIFIC', 'FIRST_APPS_TO_INTEGRATE']) satisfies z.ZodType<AppCategory>;
const IdTypeSchema = z.enum(['PERSONAL_EMAIL', 'PERSONAL_MAIN_EMAIL', 'PERSONAL_SUB_EMAIL', 'PERSONAL_PHONE', 'PERSONAL_SNS_ID', 'WORKER_EMAIL', 'WORKER_MAIN_EMAIL', 'WORKER_SUB_EMAIL', 'WORKER_MAIN_PHONE', 'WORKER_SUB_PHONE', 'EMPLOYEE_NUMBER', 'EMPLOYEE_ID', 'EMPLOYEE_SUB_ID', 'MANUAL_ASSIGN']) satisfies z.ZodType<IdType>;
export const TabKey = {
  REGISTERED: 'registered',
  TOLERATED: 'tolerated',
  BLOCKED: 'blocked',
  ALL: 'all'
} as const;
export type TabKey = (typeof TabKey)[keyof typeof TabKey];
export const TabKeySchema = z.enum(['registered', 'tolerated', 'blocked', 'all']);
export const ColumnKey = {
  TRACEABLE_APP: 'traceableApp',
  CATEGORY: 'category',
  UNIQUE_USER_COUNT: 'uniqueUserCount',
  ACCESS_PERSONS: 'accessPersons',
  ACCESS_COUNT_7_DAYS: 'accessCount7Days',
  ACCESS_COUNT_30_DAYS: 'accessCount30Days'
} as const;
export type ColumnKey = (typeof ColumnKey)[keyof typeof ColumnKey];
export const SortableColumnKey = {
  TRACEABLE_APP: ColumnKey.TRACEABLE_APP,
  UNIQUE_USER_COUNT: ColumnKey.UNIQUE_USER_COUNT,
  ACCESS_COUNT_7_DAYS: ColumnKey.ACCESS_COUNT_7_DAYS,
  ACCESS_COUNT_30_DAYS: ColumnKey.ACCESS_COUNT_30_DAYS
} as const;
export type SortableColumnKey = (typeof SortableColumnKey)[keyof typeof SortableColumnKey];
const SortableColumnKeySchema = z.enum([SortableColumnKey.TRACEABLE_APP, SortableColumnKey.UNIQUE_USER_COUNT, SortableColumnKey.ACCESS_COUNT_7_DAYS, SortableColumnKey.ACCESS_COUNT_30_DAYS]) satisfies z.ZodType<SortableColumnKey>;
export const SearchSchema = z.object({
  tab: TabKeySchema.default(TabKey.REGISTERED),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: SortableColumnKeySchema.optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
  visitUserIdIn: z.array(z.string()).optional(),
  idTypeIn: z.array(IdTypeSchema).optional(),
  traceableAppIdIn: z.array(z.string()).optional(),
  categoryIn: z.array(AppCategorySchema).optional()
});
export type SearchParams = z.infer<typeof SearchSchema>;